import React, { memo } from 'react';
import { Truck } from 'lucide-react';
import solutionsExpositor from '@/assets/solutions-expositor.webp';
import solutionsExpositor700 from '@/assets/solutions-expositor-700.webp';

const SolutionsSection = memo(() => {
  return (
    <section className="relative py-16 lg:py-24 overflow-hidden">
      {/* Decorative ambient background orb, matching the Hero's visual language */}
      <div className="absolute top-0 right-0 w-72 h-72 md:w-96 md:h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none z-0 translate-x-1/3 -translate-y-1/3"></div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          
          {/* Text Block - order 1 on mobile (top), order 2 on desktop (right) */}
          <div className="order-1 lg:order-2 flex flex-col items-start text-left w-full">
            <p className="text-primary font-bold text-sm md:text-base uppercase tracking-wider mb-3">
              Soluções Completas para o seu Negócio
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-5 md:mb-6 text-balance text-foreground">
              O Mix Perfeito para Atrair e Fidelizar seus Clientes
            </h2>
            <p className="font-body text-base md:text-lg opacity-90 leading-relaxed text-balance text-muted-foreground">
              Da crocância do pão francês tradicional aos doces e folhados mais sofisticados, a Hiperpan oferece a estrutura que sua operação precisa. Abastecemos de mini-mercados e padarias locais a grandes redes de hotéis, cafeterias e conveniências em todo o Rio Grande do Sul. Garanta vitrines sempre cheias e elimine o desperdício com nossa entrega ágil em até 24 horas.
            </p>
          </div>

          {/* Image Block - order 2 on mobile (bottom), order 1 on desktop (left) */}
          <div className="order-2 lg:order-1 w-full relative flex justify-center lg:justify-start">
            <div className="img-container-cls bg-white border border-border/50">
              <div className="absolute inset-0 bg-secondary/5 animate-pulse"></div>
              <img
                src={solutionsExpositor}
                srcSet={`${solutionsExpositor700} 700w, ${solutionsExpositor} 1000w`}
                sizes="(min-width: 1024px) 576px, (min-width: 640px) 592px, calc(100vw - 2.5rem)"
                alt="Mosaico de doces finos e folhados decorados da Hiperpan, com coberturas e acabamentos variados"
                width="1000"
                height="667"
                loading="lazy"
                className="img-content-cls relative z-10 transform hover:scale-105 transition-transform duration-700"
                style={{ objectPosition: 'center top' }}
              />
            </div>

            {/* Floating delivery stat card, anchored to the image's bottom-left corner */}
            <div className="absolute -bottom-4 -left-4 sm:-bottom-5 sm:-left-5 z-30 bg-white rounded-xl shadow-lg border-l-4 border-primary pl-3 pr-4 py-2.5 sm:pl-4 sm:pr-5 sm:py-3 flex items-center gap-2.5 sm:gap-3 max-w-[calc(100%-2rem)]">
              <div className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                <Truck className="w-4 h-4 sm:w-5 sm:h-5" />
              </div>
              <div className="leading-tight">
                <p className="font-heading text-lg sm:text-xl font-extrabold text-foreground">24h</p>
                <p className="text-[11px] sm:text-xs text-muted-foreground font-semibold">entrega em todo o RS</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
});

SolutionsSection.displayName = 'SolutionsSection';
export default SolutionsSection;